import defineComponent from 'flight';
import $ from 'static/script/libs/jquery';
import _ from 'static/script/libs/underscore';
import memberInfo from 'static/script/app/data/member-info';

function TempData() {

    this._process = function (actions) {
        let tempDataString = this.$node.val();
        let tempData = JSON.parse(tempDataString);

        _.each(tempData, function (value, key) {
            if (actions[key]) {
                actions[key](value);
            }
        }.bind(this));
    };

    this.after('initialize', function () {
        let actions = {
            'justLoggedIn': this._justLoggedIn.bind(this),
            'justLoggedInV2': this._justLoggedInV2.bind(this),
            'errorMessage': this._errorMessage.bind(this)
        };

        this._process(actions);
    });

    this._justLoggedIn = function (value) {
        if (!!value) {
            let payload = { memberId: memberInfo.memberId };
            this.trigger(document, 'data:login:logged-in', payload);
        }
    };

    this._justLoggedInV2 = function (value) {
        if (!!value) {
            let payload = { memberId: memberInfo.memberId, version: 'V2' };
            this.trigger(document, 'data:login:logged-in', payload);
        }
    };

    this._errorMessage = function (value) {
        if (!!value) {
            let payload = { message: value };
            this.trigger(document, 'ui:error:show', payload);
        }
    };
}

module.exports = defineComponent.component(TempData);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/temp-data.js